import React, { useState, useEffect, useRef } from 'react';
import Logo from '../assets/figma/jislogo-trans.png'; 
import Bar from '../assets/bar.jpg';
import '../styles/register.css'
import { Link, useNavigate } from 'react-router-dom';
import DynamicIcon from '../components/dynamicicon';
import Case_Search from '../components/core/case_search';
import { Search } from '@mui/icons-material';
import JisInput from '../components/controls/jisInput';
import JisInputView from '../components/controls/jisinputView';
import JisCheckbox from '../components/controls/jisCheckbox';
import JisButton from '../components/controls/jisButton';
import JisDropdown from '../components/controls/jisDropdown';
import * as Constants from '../constants';
import FlowItem from '../components/controls/flowitem';
import BackLoader from '../components/backloader';
import JisAlert from '../components/jisalert';
import JisTabButton from '../components/controls/jisTabButton';

function Register() {
    const navigate = useNavigate();
    const [staySigned, setStaySigned] = useState(false)
    const [user, setUser] = useState({username:'', roleId:null, isOrg:null, isPayid:null,businessType:'RC', nin:'',rcNumber:'',businessIndustry:'',payerid:''});
    const [flow, setFlow] = useState({pos:1, code:"usertype"});
    const [homeview, setHomeView] = useState('')
    const [flowerror, setFlowError]=useState('');
    const inputRef = useRef();
    const [states, setStates] =useState([]);
    const [Lga, setLga] = useState([]);
    const [cities, setCities] = useState([]);
    const [loading, setLoading] = useState(false);
    const [payidgen, setPayidgen] = useState(false);
    const [isNin, setIsNin]=useState(true);
    const [isPass, setIsPass]=useState(true);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isValidated, setIsValidate] = useState(false);
    const [is_username_valid, setIsUsernameValid] = useState(false);
    const [isValidating, setIsValidating] =useState(false);
    const [locs, setLocs]=useState({state:null,lga:null,city:null})
    const [passMismatch, setPassMismatch]=useState(null);
    const [payeridValidation, setPayeridValidation]=useState(null);
    const [payIdCreated, setPayIdCreated] = useState(false);
    const [showflow, setShowFlow] = useState(true);
    

    const gender=[
        {label:'Male',value:'M'},
        {label:'Female', value:'F'}
    ]
    const businessType=[
        {label:'RC',value:'RC'},
        {label:'BN', value:'BN'},
        {label:'IT', value:'IT'}
    ]
    const maritalstatus=[
        {label:'Married',value:'M'},
        {label:'Single', value:'S'},
        {label:'Widow/Widower',value:'W'},
        {label:'Divorced', value:'D'}
    ]

     const onUserChange = (e) => {
    setUser({...user, [e.target.name]: e.target.value})
    if(e.target.name=='userName'){
        setIsValidate(false);
    }
}


  useEffect(() => {

    onGetStates();
   
     
  }, [])

  useEffect(() => {

   if(payeridValidation!=null){
    //proceed
   // setFlow({pos:4,code:"access"})
   console.log(payeridValidation);
   if(payeridValidation.Status=='SUCCESS'){
    const pid=payeridValidation.Pid?.match(/\(([A-Z]-\d+)\)/i);
    
    setPayIdCreated(true);
    setUser({...user,payerid:pid[1]}); 

   }
   else {
    if(payeridValidation.status){
         setFlowError(`${payeridValidation.status} - ${payeridValidation.statusMessage}`);
    }else{
         setFlowError(`${payeridValidation.Status} - ${payeridValidation.StatusMessage}`);
    }
   
   }
   
   }
   
     
  }, [payeridValidation])

  useEffect(() => {

    if(homeview=='legal'){
        setUser({...user, isLegalCounsel:true,isOrg:null, roleId:Constants.Legal_Role_id})

    }else if(homeview=='nonlegal') {
        setUser({...user, isLegalCounsel:false,isOrg:null, roleId:Constants.Non_Legal_Role_id})
        
    }else if(homeview=='affi'){
        setUser({...user, isLegalCounsel:false,isOrg:null, roleId:Constants.Affidavit_Role_id})
    }
   
    setFlowError('');
     
  }, [homeview])

  useEffect(() => {
    if(user.state){
        onGetLgs(user.state);
    }
    
     
  }, [user.state])

  useEffect(() => {
    if(user.lga){
    onGetCities(user.lga);
    }
    
     
  }, [user.lga])

  useEffect(() => {
    console.log(flow);
    console.log(user);
  }, [flow])

    const onUsertype=()=>{
      
        if(user.roleId==null)
        {
            setFlowError('Please select one of the options');
            return;
        }
        
        if(user.roleId!=null && user.roleId!=Constants.Affidavit_Role_id && user.isOrg==null){
            setFlowError('Please select if you are individual or Organization');
            return;
        }
        
setFlowError('');
        setFlow({pos:2,code:"bio"});
    }
        const onBio=(e)=>{
             e.preventDefault();
             

             setFlow({pos:4,code:"access"});
            
        }
        const onPayId=(e)=>{
           
            if(user.isPayid ==null){
                setFlowError('Please choose within the available option');
                return;
            }
                setFlow({pos:2,code:"bio"});
setShowFlow(true);
           /*  if(user.isPayid==false){
                //it means we will generate PAyid
               onCreatePayerId();
            }else{
                //onValidatePayerId();
                onPayIdCreate();
            } */
           // setFlow({pos:4,code:"access"})
        }

        const onAccess=(e)=>{
            e.preventDefault();
             setPassMismatch(false);
            if(user.password!=user.confirmpassword){
                setPassMismatch(true);
                return;
            }
            if(isValidating){
                setFlowError("ongoing validation for username..");
                return;
            }
            setFlow({pos:5,code:"confirm"});
        }
        const onConfirm=()=>{
            onSave();
        }

const onBack=()=>{
    if(flow.code=='usertype'){
        navigate('/');
    }else if(flow.code=='bio'){
        setFlow({pos:1,code:"usertype"});
        setShowFlow(true);
    }
    else if(flow.code=='payid'){
        setFlow({pos:1,code:"usertype"});
        setShowFlow(true);
    }else if(flow.code=='access'){
        setFlow({pos:2,code:"bio"});
        setShowFlow(true);
    }
    setFlowError('');
}
 const onGetStates= async()=>{
    //for account registration
    try {
      setLocs({...locs,state:false});
        const resp = await fetch(`${Constants.apiUrl}/profile/states`, { 
          method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': '',}, });  
        const data = await resp.json();
       setStates(data); 
       setLocs({...locs,state:true});
      } catch (error) {
       setLocs({...locs,state:null});
        console.error(error);   
      }
}

const onGetLgs= async(stateid)=>{
    //for account registration
    try {
      setLocs({...locs,lga:false});
        const resp = await fetch(`${Constants.apiUrl}/profile/lgs/${stateid}`, { 
          method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': '',}, });  
        const data = await resp.json();
       setLga(data);
       setLocs({...locs,lga:true});
      } catch (error) {
        setLocs({...locs,lga:null});
        console.error(error);   
      }
}

const onGetCities= async(lgid)=>{
    //for account registration
    try {
      setLocs({...locs,city:false});
        const resp = await fetch(`${Constants.apiUrl}/profile/cities/${lgid}`, { 
          method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': '',}, });  
        const data = await resp.json();
       setCities(data);
       setLocs({...locs,city:true});
      } catch (error) {
        setLocs({...locs,city:null});
        console.error(error);   
      }
}

const onSave=async(e) =>{

  e.preventDefault();
             setPassMismatch(false);
            if(user.password!=user.confirmpassword){
                setPassMismatch(true);
                console.log('error')
                return;
            }
            if(isValidating){
                setFlowError("ongoing validation for username..");
                return;
            }
        setLoading(true)
        try {
          
            var _user={...user,isOrg:user.isOrg==null?false:user.isOrg};

          const resp = await fetch(`${Constants.apiUrl}/profile/signup`, {
            method: 'POST',
            body:JSON.stringify(_user) ,
            headers: {
              'Content-Type': 'application/json, text/plain',
              'Authorization': '',
            },
          });
          
          const data = await resp.json();
          setLoading(false);

       //   setFlow({pos:6,code:"congrat"})
       if(data.code==0){
        setIsSuccess(true);
       }
       else{
        console.log(data);
        console.log(`the error received.`);
        setFlowError(data.status)
       }
          
          
        } catch (error) {
          setLoading(false);
          console.error(error);
          setFlowError('cannot connect to the server at the moment. Try again')
         // onMove();
        }
}

const onCreatePayerId=async() =>{
    setFlowError('')
    setPayeridValidation(null);
console.log(user.nin);
            if(!user.isOrg && (user.nin==undefined || user.nin=='') ){
                setFlowError(`Please provide NIN information`);
                return;
            }
            if(user.isOrg && (user.businessType=='' || user.rcNumber=='' || user.businessIndustry=='') ){
                setFlowError(`Please provide Organization details`);
                return;
            }

        setLoading(true)
        try {
          
            var _user={...user,isOrg:user.isOrg==null?false:user.isOrg};

          const resp = await fetch(`${Constants.apiUrl}/profile/create-payer-id`, {
            method: 'POST',
            body:JSON.stringify(_user) ,
            headers: {
              'Content-Type': 'application/json, text/plain',
              'Authorization': '',
            },
          });
          
          const data = await resp.json();
          setLoading(false);

       if(data.code==0){
            setPayeridValidation(data.payerid);
       }
       else{
        console.log(data);
        console.log(`the error received.`);
        setFlowError(data.satus)
       }
          
          
        } catch (error) {
          setLoading(false);
          console.error(error);
          setFlowError('cannot connect to the server at the moment. Try again')
         // onMove();
        }
}
const onValidatePayerId=async() =>{
 setFlowError('')
 setPayeridValidation(null);
        setLoading(true)
        try {
          
            var _user={...user,isOrg:user.isOrg==null?false:user.isOrg};

          const resp = await fetch(`${Constants.apiUrl}/profile/validate-payerid/${user.payerid}`, {
            method: 'POST',
           // body:JSON.stringify(_user) ,
            headers: {
              'Content-Type': 'application/json, text/plain',
              'Authorization': '',
            },
          });
          
          const data = await resp.json();
          setLoading(false);

       if(data.code==0){
       
       }
       else{
        console.log(data);
        console.log(`the error received.`);
        setFlowError(data.satus)
       }
          
          
        } catch (error) {
          setLoading(false);
          console.error(error);
          setFlowError('cannot connect to the server at the moment. Try again')
         // onMove();
        }
}


const onUsername_blur=async()=>{
    if(user.userName==''){
        return;
    }
    setIsValidating(true);
    try {
          setLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/profile/validate/${user.userName}`, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            
            const data = await resp.json();
            setLoading(false);
           setIsValidating(false);
           setIsUsernameValid(data.status);
           setIsValidate(true);
           setFlowError('');
           if(!data.status){
            setFlowError(`The username [ ${user.userName} ] is already in use on the stystem. Please provide another username`)
           setUser({...user,userName:''});
        }
           
          } catch (error) {
            setLoading(false);
            console.error(error);
            
          }
}

const onSuccessRegister = () =>{
    setIsSuccess(false);
    navigate('/'); //navigate to login
}

const onPayIdCreate=()=>{
    setPayIdCreated(false);
    // setFlow({pos:4,code:"access"})
}

const onSelectType=(tp)=>{
    setHomeView(tp)
    setShowFlow(false);

    if(tp=='affi'){
            setUser({...user, roleId:Constants.Affidavit_Role_id})
            setFlow({pos:2,code:"bio"});
    }else if(tp=='legal'){
        setUser({...user, roleId:Constants.Legal_Role_id})
         setFlow({pos:3,code:"payid"});

    }else{
        setUser({...user, roleId:Constants.Non_Legal_Role_id})
        setFlow({pos:3,code:"payid"});
    }
   
    //setFlow({pos:3,code:"payid"})
}

  return (
    <div className='reg_container'>
       <BackLoader open={loading} />  
 
{payIdCreated && <JisAlert title="PayerID Creation" subtitle={payeridValidation?.Pid} onOk={onPayIdCreate} actiontext='Continue' icon="done" />}  
      <div class="homeside">
        <div style={{flex:1}}>
             <img src={Logo} alt="JIS Logo" className='logo' style={{width:100}}/> 
        </div>
      
       
                <div className="boxx">
                    
                    <p className="text"><div>1. </div> <div> You can register as a Legal Counsel, Non-legal Counsel and also do E-Affidavit.</div></p>
                    <p className="text"> <div>2.</div><div className='dtext'>For Individual and Organisation registration you need a Payer ID.</div> </p>
                    <p className="text"><div>3. </div><div className='dtext'>If you have a Payer ID select the option "I have a Payer ID</div> </p>
                    <p className="text"><div>4. </div><div className='dtext'>If you do not have a Payer ID select the option "I do not have a Payer ID</div> </p>
                    <p className="text"><div>5. </div><div className='dtext'>If you do not have a Payer ID you can generate the Payer ID during the registration process.
                     It is mandatory  to enter the NIN when the fields are displayed.</div> </p>
                    <p className="text"> <div>6.</div><div className='dtext'> Once you are done with the last step, click the "Submit" button
                     to complete the registration process.</div></p>
                </div>
</div>
   {!isSuccess && <div className='contentside'>
    
    <div className='form-center'>
        <div className='form-box'>
            <div className="boo" onClick={onBack}>
                        <DynamicIcon size={16} iname="chevron-left" />
                        <a className="back">Back</a>
                    </div>
   {flow.code=='usertype' && <div className='content-title'>Let's get started</div>}  
   {flow.code=='payid' && <div  className='content-title'>Verify Payer ID Status</div>}  
        <div className='regform'>
         {showflow && <div className='flow'>
                <div className='itemgroup'>
                    <FlowItem flow={flow} pos={1} code="usertype" title="User Type" />
                    <FlowItem flow={flow} pos={2} code="bio" title="Bio Data" />
                    <FlowItem flow={flow} pos={3} code="access" title="Access"  isLast={true}/>
                </div>
                
            </div>}   
          {flow.code=='usertype' && <div className='view'>
               <div className='homeview'> 
                <div>Select your user type</div>

                <div className='bighead-group'>
                 <div className={`bighead ${homeview=='legal'?' active':''}`} onClick={()=> onSelectType('legal')}>
                    <div className='bighold'>
                        <DynamicIcon iname="user-round" size={64} />
                        <div className='title'>Legal Counsel</div>
                    </div>
                    <p className='subtitle'>A Legal counsel can register as Individual or Organization.</p>
                </div>
                   
                <div  className={`bighead ${homeview=='nonlegal'?' active':''}`} onClick={()=> onSelectType('nonlegal')}>
                    <div className='bighold'>
                        <DynamicIcon iname="circle-user" size={64}/>
                        <div className='title'>Non-Legal Counsel</div>
                    </div>
                    <p className='subtitle'>A Non-Legal counsel can register as Invidual or Organization.</p>
                </div>
                 
                <div  className={`bighead ${homeview=='affi'?' active':''}`} onClick={()=> onSelectType('affi')}>
                    <div className='bighold'>
                        <DynamicIcon iname="book-text" size={64} />
                        <div className='title'>E-Affidavit</div>
                    </div>
                    <p className='subtitle'>An individual or Organization registering to obtain an Affidavit.</p>
                </div>
                </div>

                   <div style={{textAlign:'center', margin:20}}>Already an existing user? 
                    <Link className='special-link' to="/login"> Login</Link></div>
                 
              
               
               {flowerror!='' && <div className='error'>{flowerror}</div>} 
               
                 
            </div> 
            </div>}  
            
            
         {flow.code=='bio' && <div className='view'>
            <div className='tab_body'>
                <div className='tab_section'>
                    <JisTabButton code="user" isActive={!user.isOrg}  title="Individual" data={null} isRoleBased={false}  onClick={()=>setUser({...user,isOrg:false})}/>
                    <JisTabButton code="org" isActive={user.isOrg}  title="Organization" data={null}  isRoleBased={false} onClick={()=> setUser({...user,isOrg:true})}/>    
                </div>
            </div>
            <form  onSubmit={onBio} >
                
                <div style={{display:'flex'}}>
                <div style={{flex:1}}>
                  {user.isOrg ?
                  <div  className="input-group">
                        <label> Organization Name</label>
                        <div className='input-wrapper'>
                            <DynamicIcon iname="person_3" />
                            <input placeholder='Organization Name' required={true} name="firstName" value={user.firstName} onChange={onUserChange}   />
                        </div>
                    </div>
                  
                  :
                 <div>
                        <div style={{width:300}}>

                          <div className="select-group">
                            <label> Title <span className="required">*</span></label>
                            <select name="suffix" value={user.suffix} onChange={onUserChange} required>
                                <option value="">Select Title</option>
                                <option  value="Mr">Mr</option>
                                <option value="Mrs">Mrs</option>
                                <option value="Miss">Miss</option>
                                <option value="Barrister">Barrister</option>
                                <option value="Dr">Dr</option>
                                <option value="Dr(Mrs)">Dr(Mrs)</option>
                                <option value="Chief">Chief</option>
                                <option value="Chief(Mrs)">Chief(Mrs)</option>
                                <option value="Engr">Engr</option>
                                <option value="Engr(Mrs)">Engr(Mrs)</option>
                                <option value="Alhaji">Alhaji</option>
                                <option value="Alhaja">Alhaja</option>
                                <option value="Rev">Rev</option>
                                <option value="Pastor">Pastor</option>
                                <option value="Admiral">Admiral</option>
                                <option value="General">General</option>
                                <option value="Air Comm.">Air Comm.</option>
                                <option value="Captain">Captain</option>
                                <option value="Lt. Col">Lt. Col</option>
                                <option value="Rev(Mrs)">Rev(Mrs)</option>
                                <option value="Bishop">Bishop</option>
                                <option value="Arch Bishop">Arch Bishop</option>
                                <option value="Primate">Primate</option>
                                <option value="Architect">Architect</option>
                            </select>
                        </div>   
                        </div>
                        
                     
                    <div style={{display:'flex'}}>
                        <div  className="input-group">
                            <label>Surname/Last name <span className="required">*</span></label>
                            <div className='input-wrapper'>
                                <DynamicIcon iname="person_3" />
                               <input  name="lastName" required={true} value={user.lastName} onChange={onUserChange} 
                               placeholder='Surname/Lastname'  />
                            </div>
                        </div>
                        <div  className="input-group">
                            <label> First Name <span className="required">*</span></label>
                            <div className='input-wrapper'>
                                <DynamicIcon iname="person_3" />
                             <input label="" placeholder='Firstname' required={true} name="firstName" value={user.firstName} onChange={onUserChange}   />
                            </div>
                        </div>

                        <div  className="input-group">
                            <label> Middle Name</label>
                            <div className='input-wrapper'>
                                <DynamicIcon iname="person_3" />
                        <input label="" placeholder='Middle Name'  name="middleName" value={user.middleName} onChange={onUserChange}  />
                            </div>
                        </div>
                        
                        
                    </div>
                 </div>
                  } 

                   {user.roleId!=Constants.Affidavit_Role_id && <div  className="input-group">
                            <label>Address <span className="required">*</span></label>
                            <div className='input-wrapper'>
                                <DynamicIcon iname="add_home" />
                                <input placeholder='Address ' name="address1" required={true} value={user.address1} onChange={onUserChange}  />
                            </div>
                        </div>}     
                        
                   
                    

                {(!user.isOrg && user.roleId!=Constants.Affidavit_Role_id) 
        && !user.isPayid
                && <div style={{display:'flex'}}>
                    
                     <div  className="input-group">
                            <label> Date of Birth <span className="required">*</span></label>
                            <div className='input-wrapper'>
                                <DynamicIcon iname="calendar-days" />
                               <input placeholder='Date of Birth' type="date" required name="dateOfBirth" value={user.dateOfBirth} onChange={onUserChange} 
                        />
                            </div>

                        </div>
                         <div className="select-group">
                            <label>
                                Gender  <span className="required">*</span>
                            </label>
                            <select name="sex" value={user.sex} required={true} onChange={onUserChange} >
                                <option value="">Select gender</option>
                                {gender.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                </option>
                                ))}
                            </select>
                            </div>

                            <div className="select-group">
                            <label> Marital Status <span className="required">*</span></label>
                   
                            <select  name="maritalStatus" value={user.maritalStatus} onChange={onUserChange} required={true}>
                                <option value="">Select marital Status</option>
                                {maritalstatus.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                </option>
                                ))}
                            </select>
                            </div>
                        

                        
                    </div>}    

                    <div  style={{display:'flex'}}>
                         <div  className="input-group">
                            <label> Primary Email <span className="required">*</span></label>
                            <div className='input-wrapper'>
                                <DynamicIcon iname="email" />
                               <input  name="primaryEmail" type="email" required value={user.primaryEmail} onChange={onUserChange} 
                               placeholder='Email'  />
                            </div>

                        </div>
                         <div  className="input-group">
                            <label> Primary Phone <span className="required">*</span></label>
                            <div className='input-wrapper'>
                                <DynamicIcon iname="phone_in_talk" />
                              <input placeholder='Primary Phone Number' name="primaryContactNumber" required={true} value={user.primaryContactNumber}  onChange={onUserChange}  /> 
                            </div>
                        </div>
                     {homeview=='affi' && <div  className="input-group">
                            <label>PayerID </label>
                            <div className='input-wrapper'>
                                <DynamicIcon iname="card" />
                               <input placeholder={`${user.isOrg?'C':'N'}-123456`} name="payerid" pattern="^(N|C)-\d{1,12}$" value={user.payerid} title="Must start with N- or C- followed by 4 to 12 digits"
                                 onChange={onUserChange} max={15} />
                            </div>
                        </div>}
                       
                    {!user.isOrg && user.isPayid==false && <div>
                        <div  className="input-group">
                            <label>{'NIN'} {user.isOrg} <span className="required">*</span></label>
                            <div className='input-wrapper'>
                                <DynamicIcon iname="card" />
                              <input  placeholder={`Enter your NIN number`} name="nin" type="number" maxLength={11} value={user.nin} required onChange={onUserChange} /> 
                            </div>
                        </div>
                           
                            
                        
                    </div>} 

                       {user.isPayid==true && <div>
                        <div  className="input-group">
                            <label>PayerID <span className="required">*</span></label>
                            <div className='input-wrapper'>
                                <DynamicIcon iname="card" />
                               <input placeholder={`${user.isOrg?'C':'N'}-123456`} name="payerid" pattern="^(N|C)-\d{1,12}$" value={user.payerid} title="Must start with N- or C- followed by 4 to 12 digits"
                                required onChange={onUserChange} max={15} />
                            </div>
                        </div>
                        
                    </div>}
                    </div>

                     {user.isOrg && user.isPayid==false && <div style={{display:'flex'}}>
                    <div className="select-group">
                            <label> Business Type <span className="required">*</span></label>
                   
                            <select  name="businessType" value={user.businessType} onChange={onUserChange} required={true}>
                                <option value="">Select Business Type</option>
                                {businessType.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                </option>
                                ))}
                            </select>
                            </div>
                        <div  className="input-group">
                            <label>{user.businessType} Number <span className="required">*</span></label>
                            <div className='input-wrapper'>
                                <DynamicIcon iname="card" />
                              <input  placeholder={`Enter your ${user.businessType} Number`} name="rcNumber"  type='number' maxLength={15} value={user.rcNumber} required onChange={onUserChange} /> 
                            </div>
                        </div>
                        <div  className="input-group">
                            <label> Industry <span className="required">*</span></label>
                            <div className='input-wrapper'>
                                <DynamicIcon iname="card" />
                              <input  placeholder={`Enter your Business Industry`} name="businessIndustry"  maxLength={100} value={user.businessIndustry} required onChange={onUserChange} /> 
                            </div>
                        </div>   
                            
                        
                    </div>}

                    



                  {user.roleId!=Constants.Affidavit_Role_id && <div style={{display:'flex'}}>
                        
                         <div className="select-group">
                            <label> State <span className="required">*</span></label>
                            <select name="state" required={true} value={user.state} onChange={onUserChange} >
                                {locs.state==null  && <option value="">Select State</option>}
                                {locs.state==false && <option value="">loading state</option>}
                                {locs.state  && <option value="">Select state</option>}
                                {states.map((opt) => (
                                <option key={opt.id} value={opt.id}>
                                    {opt.title}
                                </option>
                                ))}
                            </select>
                            </div>
                        <div className="select-group">
                            <label> L.G.A <span className="required">*</span></label>
                            <select  name="lga" value={user.lga} required={true} onChange={onUserChange}>
                                {locs.lga==null  && <option value="">Select State first</option>}
                                {locs.lga==false && <option value="">loading LG</option>}
                                {locs.lga  && <option value="">Select LG</option>}
                                {Lga.map((opt) => (
                                <option key={opt.id} value={opt.id}>
                                    {opt.title}
                                </option>
                                ))}
                            </select>
                            </div>
                       <div className="select-group">
                            <label> City <span className="required">*</span></label>
                            <select  name="city" value={user.city} required={true} onChange={onUserChange}>
                                {locs.city==null  && <option value="">Select LGA first</option>}
                                {locs.city==false && <option value="">loading cities</option>}
                                {locs.city && <option value="">Select City</option>}
                                {cities.map((opt) => (
                                <option key={opt.id} value={opt.id}>
                                    {opt.title}
                                </option>
                                ))}
                            </select>
                            </div>
                    </div> }  
                  
                  {user.isLegalCounsel && <div>
                    <div  className="input-group">
                            <label> Supreme Court Number<span className="required">*</span></label>
                            <div className='input-wrapper'>
                                <DynamicIcon iname="phone_in_talk" />
                              <input placeholder='Supreme Court Number' name="barNumber" required={true} value={user.barNumber}  onChange={onUserChange} maxLength={9}  /> 
                            </div>
                        </div>
                        <note>Legal counsel is required to provide Supreme Court Number</note>
                    </div>} 
                     {!user.isPayid &&  user.roleId!=Constants.Affidavit_Role_id && <div className='payeridbox'>
    <div  className="input-group">
                     
                            <div className='input-wrapper'>
                                <DynamicIcon iname="card" />
                               <input placeholder={`${user.isOrg?'C':'N'}-123456`} readOnly name="payerid" pattern="^(N|C)-\d{1,12}$" value={user.payerid} title="Must start with N- or C- followed by 4 to 12 digits"
                                required onChange={onUserChange} max={15} />
                            </div>
                        </div>
      {(user.payerid=='' ) && <JisButton onClick={onCreatePayerId}>Generate Payer ID</JisButton>                  }  
</div>} 
                </div> 
            </div>
               {flowerror!='' && <div className='error'>{flowerror}</div>} 
                 <div className='button-spread'>
                        <JisButton type='submit' >Continue</JisButton>
                    </div>
            </form>

            </div>}   
         {flow.code=='access' && <div className='view'>
            <form onSubmit={onSave}>
                <h2>Access Information</h2>
                <div style={{display:'flex', flexDirection:'row'}}>
                    <div style={{flex:1}}>
                    <div>
                        <div  className="input-group">
                            <label> Username <span className="required">*</span></label>
                            <div className='input-wrapper'>
                                <DynamicIcon iname="person_3" />
                             <input  placeholder='User name'name="userName" maxLength={50} value={user.userName} onChange={onUserChange} required onBlur={onUsername_blur}/>  
                            </div>
                            <div>{isValidating && <div className="spinner2" ></div>}</div>
                            {isValidated && (is_username_valid?<span className='success-msg'>The username is valid</span>:<span className='error'>{flowerror}</span>)}
                        </div>
                        
                    </div>
                    <div style={{display:'flex'}}>
                        <div  className="input-group">
                            <label>Password <span className="required">*</span></label>
                            <div className='input-wrapper'>
                                <DynamicIcon iname="lock" />
                                <input placeholder='password' type={`${isPass?'password':'text'}`} name="password" value={user.password} onChange={onUserChange} required />   
                                 <DynamicIcon iname={`${isPass?'eye':'eye-off'}`} onClick={()=> setIsPass(!isPass)} /> 
                            </div>
                        </div>
                        <div  className="input-group">
                            <label> Confirm Password <span className="required">*</span></label>
                            <div className='input-wrapper'>
                                <DynamicIcon iname="lock" />
                               <input placeholder='confirmpassword 'name="confirmpassword" type={`${isPass?'password':'text'}`} value={user.confirmpassword} onChange={onUserChange} required />    
                            </div>
                           {passMismatch==true && <div className='error-msg'>Verify Password and Password must be same</div>} 
                        </div>
                        
                    </div>

                  {/*   <div>
                        <div  className="input-group">
                            <label> Security Answer <span className="required">*</span></label>
                            <div className='input-wrapper'>
                               <input  placeholder='securityanswer' name="securityanswer" value={user.securityanswer} onChange={onUserChange} required />    
                            </div>
                        </div>
                        <div className="select-group">
                            <label> Security Question <span className="required">*</span></label>
                            <select name="securityquestion" value={user.securityquestion} onChange={onUserChange} required>
                                <option value="">Select Security Question </option>
                                {gender.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                </option>
                                ))}
                            </select>
                     </div>
                    </div> */}
                    
                    </div>
            
            </div>
               {flowerror!='' && <div className='error'>{flowerror}</div>} 
            <div  className='button-spread'>
          
                <JisButton type='submit'>Continue</JisButton>
            </div>
            
        </form>
            </div>}   

         {flow.code=='payid' &&  <div className='view'>
               
               <div style={{flex:1, marginTop:50}}>
<form >   
                    <p style={{ marginTop:24}}>
                        <div className={`selected ${user.isPayid==false?'active':''}`} style={{display:'flex'}} 
                        onClick={()=> setUser({...user, isPayid:false})}> <span style={{flex:1}}> I do not have payer ID to be used for this registration but would like to generate one</span> <span> <DynamicIcon size={30} iname={`${user.isPayid==false?'check_circle':'radio_button_unchecked'}`}/></span> </div> 
                           
                        <div  className={`selected ${user.isPayid==true?'active':''}`} style={{display:'flex'}}  
                        onClick={()=> setUser({...user, isPayid:true})}><span style={{flex:1}}> I have payer ID that will be used for this registration</span> <span> <DynamicIcon size={30} iname={`${user.isPayid==true?'check_circle':'radio_button_unchecked'}`}/></span> </div>
                    
                    
                    </p>
                 
                  {flowerror!='' && <div className='error'>{flowerror}</div>}  
                    <div  className='button-spread'>
                        <JisButton onClick={onPayId}>Continue</JisButton> 
                   </div>
                </form>
               </div>
                 
           
           

            </div>}  
      

            {flow.code=="congrat" && <div className='view'>
                congratulation message with going to login info
                </div>} 
        </div> 
        </div>

   
      </div>
   </div>
        
        }   
     {isSuccess && <div className='success-final'>
            <div className='success-div'>
                <div className='success-ball'>
                    <DynamicIcon iname="check" size={64} color="white" />
                </div>
                <div style={{fontSize:24, fontWeight:600}}>Account Creation Sucessful</div>
                <div style={{fontWeight:400, marginBottom:24}}>Your E-Filing account has been successfully created. Please log in to continue.</div>
                <JisButton onClick={()=>navigate('/login')}>Login</JisButton>
            </div>
      </div>}  
 <div>

 </div>
    </div>
  );
}

export default Register;